class LocalCache {
	// 添加
	setCache(key, value, ttl=0) {
		key = "zz_" + key
		if(value){
			const now = new Date().getTime();
			const item = {
				value: value,
				expiry: ttl == 0 ? 0 : now + ttl,
			};
			
			localStorage.setItem(key, JSON.stringify(item));
		}else{
			localStorage.removeItem(key);
		}
	}
	// 查找
	getCache(key) {
		key = "zz_" + key
		const itemStr = localStorage.getItem(key);
		if (!itemStr) {
			return null;
		}
		const item = JSON.parse(itemStr);
		const now = new Date().getTime();
		if (now > item.expiry && item.expiry > 0) {
			localStorage.removeItem(key);
			return null;
		}
		return item.value;
	}
	// 删除
	deleteCatch(key) {
		key = "zz_" + key
		localStorage.removeItem(key);
	}
	// 清理
	clearCache() {
	  localStorage.clear()
	}
  }
  export default new LocalCache()